module.exports = __webpack_public_path__ + "static/media/local-18.bf8cef80.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-18.png
// module id = 1182
// module chunks = 2